/**
 * In-page `#id` → `.anchor-point` navigation.
 * No header inset: scroll target is document Y from offsetTop chain (top of viewport; bar may overlap).
 */
(function () {
  'use strict';

  function escId(id) {
    if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(id);
    return String(id).replace(/\\/g, '\\\\').replace(/^-/, '\\-');
  }

  function anchorPointForId(targetId) {
    if (!targetId) return null;
    try {
      var el = document.querySelector('#' + escId(targetId) + '.anchor-point');
      if (el) return el;
    } catch (e) {}
    var byId = document.getElementById(targetId);
    if (byId && byId.classList && byId.classList.contains('anchor-point')) return byId;
    return null;
  }

  /** Deliberately no clearance above the anchor (fixed header may cover the top). */
  function effectiveAnchorTopInsetPx() {
    return 0;
  }

  /** Document scroll Y to place the element's top edge at the viewport top (inset applied additively). */
  function targetScrollYForAnchor(el) {
    var top = 0;
    var node = el;
    while (node) {
      top += node.offsetTop;
      node = node.offsetParent;
    }
    return Math.max(0, top - effectiveAnchorTopInsetPx());
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToAnchorId(targetId, smooth) {
    var el = anchorPointForId(targetId);
    if (!el) return false;
    var y = targetScrollYForAnchor(el);
    var behavior = smooth && !reducedMotion() ? 'smooth' : 'auto';
    try {
      window.scrollTo({ top: y, left: 0, behavior: behavior });
    } catch (e2) {
      window.scrollTo(0, y);
    }
    return true;
  }

  function hashId() {
    return (location.hash || '').replace(/^#/, '').split('&')[0];
  }

  function afterLayout(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var targetId = href.substring(1).split('&')[0];
      if (!targetId) return;
      if (!anchorPointForId(targetId)) return;
      e.preventDefault();
      scrollToAnchorId(targetId, true);
    },
    true,
  );

  function onLoadHash() {
    var id = hashId();
    if (!id) return;
    afterLayout(function () {
      scrollToAnchorId(id, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoadHash);
  } else {
    onLoadHash();
  }

  window.addEventListener('hashchange', function () {
    var id = hashId();
    if (!id) return;
    scrollToAnchorId(id, false);
  });
})();
